import { useParams } from 'react-router-dom';
import Post from './NewPost/NewPost'
import { useEffect, useState } from 'react';
import {fetchDetailPost} from '../api/post'

const Edit = ()=>{
    const {id} = useParams();
    const ID = id;
    const [title,setTitle] = useState('');
    const [summary,setSummary] = useState('');
    const [language,setLanguage] = useState('en');
    const [translationGroup,setTranslationGroup] = useState('');
    const [content,setContent]= useState('');
    const [error,setError] = useState('');
    const [isReady,setIsReady] = useState(false);

    //获取文章数据
    const fetchData = async (ID)=>{
        try {
            const response = await fetchDetailPost(ID, 'all');
            if( response.data.code === 200){
                //标题
                setTitle(response.data.data.title);
                setSummary(response.data.data.summary || '');
                setLanguage(response.data.data.lng || 'en');
                setTranslationGroup(response.data.data.translationGroup || '');
                //内容
                try {
                    setContent(JSON.parse(response.data.data.content));
                } catch (parseError) {
                    setContent(response.data.data.content || '<p></p>');
                }
                setIsReady(true);
            }else{
                setError(response.data.message || '获取文章内容失败');
            }

        } catch (error) {
            setError(error.message || '网络请求失败，服务器可能未启动');
        }
    };

    //更新文章

    //监测id
    useEffect(()=>{
        if(ID===undefined){
            return;
        }
        fetchData(ID);
    },[ID]);

    return(
        <div>
            {isReady?<Post
            PId={ID}
            PTitle={title}
            PSummary={summary}
            PLanguage={language}
            PTranslationGroup={translationGroup}
            PContent = {content}
            />:<p>Loading</p>}
            {error&&<p style={{color:'red'}}>{error}</p>}
        </div>
    )
}
export default Edit;
